<template>
    <footer class="footer-centered section bg-gray-darker">
       <div class="shell">
           <div class="range range-sm-center">
               <div class="cell-sm-10 cell-md-8 cell-lg-6">
                    <router-link class="brand" to="/" v-scroll-to="{el:'#home', offset:-80}"><div class="brand_name"><img src="./../../assets/logo_green.png" alt="SMDigital logo" height="59"/></div></router-link>                           
                <ul class="list-icons list-inline-sm social-network-links">
                    <!-- <li><a class="icon" :href='this.instagramUrl' target="_blank"><img src="./../../icons/instagram.png" alt="SLight production instagram"/></a></li> -->
                    <li><a class="icon" :href='this.facebookUrl' target="_blank"><img src="./../../icons/facebook.png" alt="SLight production facebook"/></a></li>
                    <li><a class="icon" :href='this.youtubeUrl' target="_blank"><img src="./../../icons/youtube.png" alt="SLight production youtube"/></a></li>
                </ul>
                <router-link to="/polica-privatnosti"  class="link-underline">POLICA PRIVATNOSTI / O TVRTKI</router-link>                        
               </div>           
           </div>
       </div>
       <div class="cookie-policy" v-bind:class="{ active: isActive }">
            <p>
                Internet stranica slightproduction.hr sprema na vaše računalo određenu količinu informacija, takozvanih cookies (kolačići) kako bi posjet ovoj internetskoj stranici bio što ugodniji, funkcionalniji i praktičniji.
                Ako ste suglasni s korištenjem kolačića, molimo Vas da pritisnete "Prihvaćam". 
                Ukoliko želite saznati više, pročitajte našu
                <router-link to="/polica-privatnosti"  class="btn-link">policu privatnosti.</router-link>
            </p>
            <a @click="prihvatiKolacice()" class="button button-default-outline button-ujarak button-size-1">Prihvaćam</a>
       </div>
    </footer>
</template>
<script>
export default {   
    data () {
        return {
            isActive: false
        }
    },
    methods: {
        checkPrivacy:function(){
            return localStorage.getItem('cookie-policy')
        },
        prihvatiKolacice: function(event){
            localStorage.setItem('cookie-policy', true)
            this.isActive = false;
        }
    },
    created(){
        console.log(this.checkPrivacy());
        if(this.checkPrivacy() != 'true'){
            this.isActive=true;        
        }
    }     
}
</script>
<style lang="scss">
    footer{
        background: #d6d6d6;
        padding: 20px;
        color:#fff;

        .link-underline{
            color: #575757;
            text-decoration: none;
            margin-top:.5rem;
            &:hover{
                color: #969696;
            }
        }

        .cookie-policy{
            padding: 2rem;
            position: fixed;
            bottom: 0;
            background-color: #a7ce38; 
            width: 100%; 
            z-index: 999; 
            visibility: hidden;
            opacity: 0;
            transition: visibility 0s, opacity 0.5s linear;
            box-sizing: border-box;

            p{
                font-size: 1.1rem;
                line-height: 2rem; 
                .btn-link{
                    color:#fffca2;
                    text-decoration: underline;
                }               
            }

            &.active{
                visibility: visible;
                opacity: 1;
            }

            a{
                margin-top:1rem;
            }         
        }

        .brand_name{
            img{
                height:59px;
            }
        }
        .social-network-links{
            li{
                a{
                    img{
                        height: 24px;
                    }

                    &:hover{
                        img{
                            opacity: .8;   
                        }     
                    }
                }
            }
        }
    }

@media only screen and (max-width: 768px) {
  footer{
      .cookie-policy{
          padding: 1rem;
            p{
                font-size: 14px;
                line-height: 18px;             
            }          
      }
  }
}      
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue